module.exports = __webpack_public_path__ + "static/1-gather-people-data-ceeccfbf8d88287660f96a92df4b3ca0.mp4";